import type { Instructor } from "../../api/instructors";
import { UI_LOADING } from "../../constants/uiLabels";
import "./InstructorPillFilter.css";

type Props = {
  instructors: Instructor[];
  filterAllInstructors: boolean;
  selectedInstructorIds: string[];
  loading?: boolean;
  error?: string | null;
  onSelectAll: () => void;
  onToggleInstructor: (id: string) => void;
};

function pillLabel(fullName: string): string {
  return fullName.toLocaleUpperCase("tr-TR");
}

export function InstructorPillFilter({
  instructors,
  filterAllInstructors,
  selectedInstructorIds,
  loading,
  error,
  onSelectAll,
  onToggleInstructor,
}: Props) {
  const isAllSelected = filterAllInstructors || selectedInstructorIds.length === 0;

  return (
    <div className="kp-instr-pills">
      <span className="kp-instr-pills__label">EĞİTMEN:</span>
      {loading && <span className="kp-instr-pills__status">{UI_LOADING}</span>}
      {error && <span className="kp-instr-pills__status kp-instr-pills__status--error">{error}</span>}
      {!loading && !error && (
        <div className="kp-instr-pills__row" role="group" aria-label="Eğitmen seçimi">
          <button
            type="button"
            className={`kp-instr-pill${isAllSelected ? " is-selected" : ""}`}
            aria-pressed={isAllSelected}
            onClick={onSelectAll}
          >
            Tüm Eğitmenler
          </button>
          {instructors.map((inst) => {
            const selected = isAllSelected || selectedInstructorIds.includes(inst.id);
            return (
              <button
                key={inst.id}
                type="button"
                className={`kp-instr-pill${selected ? " is-selected" : ""}`}
                aria-pressed={selected}
                title={inst.full_name}
                onClick={() => onToggleInstructor(inst.id)}
              >
                {pillLabel(inst.full_name)}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
